import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useLocation, useParams } from 'react-router'
import { Tabs, type ITabItem } from 'shared/ui/Tabs/Tabs'
import { uiStore } from 'shared/store/uiStore'
import { ChatbotRoutes } from 'entities/ExportRouters'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'
import type { IAgentConfigureTab } from 'pages/chatbot/ui/UnifiedAgent/store/unifiedAgentStore'
import styles from './styles.module.scss'

type ITabKey = IAgentConfigureTab

const TABS: ITabItem<ITabKey>[] = [
  { key: ChatbotRoutes.chat, name: 'Create' },
  { key: ChatbotRoutes.config, name: 'Configure' },
]

export const AgentConfigureTabs = observer(() => {
  const { agentId } = useParams()
  const { pathname } = useLocation()
  const { setActiveConfigureTab } = useUnifiedAgentContext()

  const activeTabKey: ITabKey = pathname.endsWith(ChatbotRoutes.config)
    ? ChatbotRoutes.config
    : ChatbotRoutes.chat

  useEffect(() => {
    setActiveConfigureTab(activeTabKey)
  }, [activeTabKey])

  const handleSelectTab = (tab: ITabItem<ITabKey>) => {
    const path = agentId
      ? tab.key === ChatbotRoutes.chat
        ? ChatbotPath.editChat(+agentId)
        : ChatbotPath.editConfig(+agentId)
      : tab.key === ChatbotRoutes.chat
      ? ChatbotPath.newChat
      : ChatbotPath.newConfig

    uiStore.changeRoute({ path })
  }

  return (
    <Tabs<ITabKey>
      variant='circular'
      tabs={TABS}
      activeTabKey={activeTabKey}
      handleSelectTab={handleSelectTab}
      tabClassName={styles.tab}
    />
  )
})
